import { useState } from "react";
import { toast } from "sonner";
import { Mail, MessageCircle, Send, X, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

// Iconos minimalistas para enviar ticket / cotización por correo o WhatsApp (registra al cliente con el contacto capturado)
export default function EnviarDocumento({ tipo, doc, contacto, onEnviado }) {
  const [canal, setCanal] = useState(null);
  const [destino, setDestino] = useState("");
  const [nombre, setNombre] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [hecho, setHecho] = useState({});

  async function enviar(c, dest) {
    setEnviando(true);
    try {
      const { data } = await api.post(`/${tipo === "venta" ? "ventas" : "cotizaciones"}/${doc.id}/enviar`, { canal: c, destino: dest, cliente_nombre: nombre || contacto?.nombre || null });
      if (data.wa_link) { window.open(data.wa_link, "_blank"); toast.success("WhatsApp abierto con el ticket redactado"); }
      else toast.success(c === "email" ? `Correo enviado a ${dest}` : `WhatsApp enviado a ${dest}`);
      setHecho((h) => ({ ...h, [c]: dest })); setCanal(null); setDestino(""); onEnviado?.(data);
    } catch (e) { toast.error(formatApiError(e)); } finally { setEnviando(false); }
  }
  function click(c) {
    const guardado = c === "email" ? contacto?.email : contacto?.telefono;
    if (guardado) return enviar(c, guardado);
    setCanal(c); setDestino("");
  }

  return (
    <div className="space-y-2" data-testid="enviar-documento">
      <div className="flex items-center justify-center gap-3 text-brand-muted">
        <button type="button" data-testid="enviar-whatsapp-btn" onClick={() => click("whatsapp")} disabled={enviando} title="Enviar por WhatsApp" className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors hover:bg-emerald-50 hover:text-emerald-600 ${hecho.whatsapp ? "text-emerald-600" : ""}`}><MessageCircle className="w-4 h-4" /></button>
        <button type="button" data-testid="enviar-correo-btn" onClick={() => click("email")} disabled={enviando} title="Enviar por correo" className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors hover:bg-brand-amber-soft hover:text-brand-amber-dark ${hecho.email ? "text-brand-amber-dark" : ""}`}><Mail className="w-4 h-4" /></button>
        {enviando && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
        {(hecho.email || hecho.whatsapp) && <span className="text-[10px]">{[hecho.whatsapp && `WhatsApp ${hecho.whatsapp}`, hecho.email && hecho.email].filter(Boolean).join(" · ")}</span>}
      </div>
      {canal && (
        <form onSubmit={(e) => { e.preventDefault(); enviar(canal, destino); }} className="flex gap-1.5 items-center animate-pop" data-testid="enviar-form">
          <input data-testid="enviar-destino-input" autoFocus required type={canal === "email" ? "email" : "tel"} value={destino} onChange={(e) => setDestino(e.target.value)} placeholder={canal === "email" ? "correo@cliente.com" : "10 dígitos"} className="field h-9 flex-1 text-sm" />
          {!contacto?.nombre && <input data-testid="enviar-nombre-input" value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Nombre (opcional)" className="field h-9 w-32 text-sm" />}
          <button type="submit" data-testid="enviar-confirmar-btn" disabled={enviando} className="btn-ink h-9 px-3 text-xs"><Send className="w-3.5 h-3.5" /> Enviar</button>
          <button type="button" onClick={() => setCanal(null)} className="p-1.5 text-brand-muted hover:text-brand-ink"><X className="w-4 h-4" /></button>
        </form>
      )}
    </div>
  );
}
